import React from 'react'

import { CartoesEnum } from 'enums/cartoes.enum'
import { formatFullName } from 'shared/functions/utils'
import { cartoesModelos } from 'utils/Cartoes'
import cardOptions from 'assets/images/cartoes/card-options.png'
import { PageText } from 'components'

import { EscolhaCartaoWrapper } from './style'

type TTypeCard = {
  cardType: string
  fullName: string
}

const CardFlagType = ({ cardType, fullName }: TTypeCard) => (
  <>
    <PageText text="O laranjinha a um passo!" margin="80px 0px 24px 0px" />

    <p className="mb-4">
      Após finalizar o processo de abertura, você poderá acompanhar a entrega do seu cartão pelo
      menu de Cartões.
    </p>

    <EscolhaCartaoWrapper>
      <div
        className={`card-container ${cardType !== 'ATHLETICO' ? 'kids' : ''}`}
        data-card-name={formatFullName(fullName)}
      >
        <img src={cartoesModelos[cardType]} alt="Cartão" />
      </div>
    </EscolhaCartaoWrapper>
  </>
)

const CardMoreTwentyThree = () => (
  <>
    <PageText text="O seu cartão Inter" margin="80px 0px 24px 0px" />

    <div className="card-container mb-4">
      <img src={cardOptions} alt="Cartão" style={{ width: '100%' }} />
    </div>

    <p className="mb-4">Cartão Gold, Platinum, Prime ou Win?</p>
    <p>Vamos analisar o seu perfil e enviar o cartão perfeito para você.</p>
  </>
)

export const TypeCard = ({ cardType, fullName }: TTypeCard) => (
  <>
    {cardType === CartoesEnum.ATHLETICO || cardType === CartoesEnum.LAION ? (
      <CardFlagType cardType={cardType} fullName={fullName} />
    ) : (
      <CardMoreTwentyThree />
    )}
  </>
)
